<template>
  <div
    class="thumbnail-carousel-item flex-shrink-0 snap-start relative cursor-pointer"
    :style="{ width: itemSize, height: itemSize }"
  >
    <div
      v-if="item.isVideo"
      class="w-full h-full"
      @click="$emit('click', item)"
    >
      <div
        :class="customClasses"
      >
        <span
          class="iconify svg--video-play"
          :class="iconClasses"
        />
      </div>
      <ImgView
        :class="imageClasses"
        :src="item.videoThumbnail"
        :alt="imageAlt"
        :width="size"
        :height="size"
      />
    </div>
    <div
      v-else
      @click="$emit('click', item)"
    >
      <div
        v-if="item.isThreeSixty"
        :class="customClasses"
      >
        <span
          class="iconify svg--three-sixty-images"
          :class="iconClasses"
        />
      </div>
      <TwicpicsImage
        v-if="item.mobile"
        :src="item.mobile.url"
        :alt="imageAlt"
        :width="size"
        :height="size"
        class="w-full h-full"
        :class="imageClasses"
      />
    </div>
  </div>
</template>

<script lang="ts">

import type { PropType } from 'vue';
import type { ThumbnailItem } from '~~/types/components/ThumbnailCarousel/ThumbnailItem';

export default defineComponent({
  name: 'ThumbnailCarouselItem',

  props: {
    item: {
      type: Object as PropType<ThumbnailItem>,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
  },
  emits: ['click'],
  setup(props) {

    const itemSize = computed(() => `${props.size}px`);
    const imageAlt = computed(() => props.item.alt || 'Image');

    return {
      itemSize,
      imageAlt,
      customClasses: 'bg-EXPONDO-primary absolute opacity-70 w-full h-full flex justify-center items-center',
      imageClasses: 'object-cover border border-EXPONDO-primary-10',
      iconClasses: 'text-EXPONDO-white text-4xl',
    };
  
  },
});


</script>
